var _style, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHkCro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 294.8",
    style: {
      enableBackground: "new 0 0 350 294.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:#F5F5F5;}\n\t.st3{opacity:0.3;}\n\t.st4{fill:#263238;}\n\t.st5{fill:#BED000;}\n\t.st6{fill:#FAFAFA;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{display:none;}\n\t.st9{display:inline;fill:#BED000;}\n\t.st10{display:inline;opacity:0.3;}\n\t.st11{display:inline;fill:#263238;}\n\t.st12{fill:#FFBE9D;}\n\t.st13{fill:#EB996E;}\n\t.st14{fill:#455A64;}\n\t.st15{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,237.1c3.1-1.5,6.7-1.9,10.1-1.2c1.8,0.3,3.7,0.9,5,2.2s1.5,3.8,0.1,5c-0.9,0.6-2,0.9-3.1,0.8 c-2.7,0-5.6-0.5-7.8,1.1c-1.2,0.9-2,2.4-3.5,2.9c-1.5,0.3-3-0.4-3.7-1.7c-0.7-1.3-0.8-2.9-0.4-4.3C30.7,239.8,32,238.1,33.8,237.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.8,223.5c1.9,2.7,5.5,1.8,7.2,0.2c1.7-1.6,2.4-4,3-6.3c1.5-5.2,3-10.6,1.9-15.8c-0.3-1.6-1-3.1-2-4.3 c-1.1-1.2-2.7-1.8-4.3-1.5c-1.8,0.5-3,2.2-3.8,4c-2.4,5.1-3.7,10.6-3.7,16.2C25,218.6,25.3,221.3,26.8,223.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,227.4c2-2.4,2.4-5.9,1.5-9c-1-3-2.9-5.7-5.3-7.7c-2.8-2.5-6-4.4-9.5-5.6c-1.4-0.6-2.8-0.8-4.3-0.7 c-1.5,0.1-2.8,0.9-3.6,2.2c-1,1.9,0,4.2,1,6.1c1.8,3.3,3.9,6.5,6.2,9.5c1.9,2.4,4,4.8,6.9,5.9c2.9,1.1,5.9,1,7.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,263.9c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.9,0.2-2,0.3-3.3c0.2-1.6,0.4-3.3,0.7-4.9c0.4-2,1-3.9,1.8-5.7 c0.7-1.9,1.7-3.6,2.9-5.2c1-1.3,2.3-2.3,3.7-3.1c1-0.5,2-0.8,3.1-1c0.4,0,0.8-0.1,1.2-0.2c-0.4,0-0.8,0-1.2,0 c-1.1,0.1-2.3,0.4-3.3,0.8c-1.5,0.7-2.9,1.8-3.9,3.1c-1.3,1.6-2.3,3.4-3,5.3c-0.8,1.9-1.3,3.8-1.8,5.8c-0.3,1.6-0.5,3.3-0.6,4.9 c-0.1,1.4-0.1,2.6-0.2,3.3C26.6,263.1,26.6,263.5,26.6,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,261.4c0-0.2,0-0.4,0-0.6v-1.6c0-1.4,0-3.4,0.1-5.9c0.1-5,0.6-10.4,1.4-18c0.7-7.1,1.8-15.5,3-20.9 c0.2-1.2,0.5-2.3,0.7-3.3c0.2-1,0.4-1.8,0.6-2.5c0.2-0.7,0.3-1.2,0.4-1.6c0.1-0.2,0.1-0.4,0.1-0.6c-0.1,0.2-0.2,0.3-0.2,0.5 c-0.1,0.4-0.3,0.9-0.5,1.6c-0.2,0.6-0.4,1.5-0.7,2.5c-0.2,1-0.5,2.1-0.7,3.3c-1.4,6.4-2.4,12.8-3.1,19.3 c-0.8,7.6-1.2,14.5-1.2,19.6c0,2.5,0,4.5,0.1,5.9c0,0.7,0.1,1.2,0.1,1.6C26.8,261,26.8,261.2,26.9,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.9,248c0-0.6,0-1.1,0-1.7c-0.1-1.5-0.3-3.1-0.5-4.6c-0.4-2.2-0.9-4.5-1.5-6.7c-0.7-2.7-1.7-5.3-2.8-7.9 c-1.9-4.7-4.7-9-8.2-12.7c-0.6-0.6-1.2-1.2-1.9-1.8c-0.3-0.3-0.6-0.5-0.8-0.7l-0.7-0.5c-0.4-0.3-0.9-0.6-1.4-0.9 c1.6,1.3,3.2,2.7,4.6,4.1c3.4,3.7,6.1,8,8,12.7c1.1,2.5,2,5.1,2.8,7.8c0.6,2.2,1.2,4.4,1.6,6.6c0.4,1.9,0.6,3.4,0.7,4.5 C26.7,246.9,26.8,247.4,26.9,248z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14,271.6 15.3,289.9 38.9,289.9 40.2,271.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 264.3,
    className: "st1",
    width: 31.4,
    height: 7.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.7,289.2 11.7,291.2 13.2,291.2 42.5,291.2 42.5,289.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.6,294.8 13.2,291.2 41.4,291.2 39.7,294.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.8,277.6l-0.1,0.2c-0.1,0.1-0.2,0.3-0.4,0.5L38,280l-0.1,0.1l-0.1-0.1l-3.4-4.7h0.2l-3.3,4.7l-0.1,0.1 l-0.1-0.1c-1.2-1.5-2.6-3-3.9-4.7h0.2l-0.2,0.3l-3.5,4.4l-0.1,0.1l-0.1-0.2c-1.2-1.7-2.3-3.3-3.3-4.7h0.2l-4.1,4.7l-0.1,0.1 l-0.1-0.1c-0.5-0.9-1-1.6-1.3-2.2l-0.3-0.6c0-0.1-0.1-0.1-0.1-0.2c0,0,0.1,0.1,0.1,0.2l0.4,0.5l1.3,2.1h-0.1l4-4.7l0.1-0.1l0.1,0.1 l3.4,4.7h-0.2l3.5-4.4l0.2-0.3l0.1-0.1l0.1,0.1l3.9,4.7h-0.2c1.2-1.7,2.3-3.3,3.4-4.7l0.1-0.1l0.1,0.1l3.3,4.7h-0.1l1.4-1.7 l0.4-0.4C39.7,277.6,39.8,277.6,39.8,277.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.6,271.4c0,0.1-5.9,0.1-13.2,0.1s-13.2-0.1-13.2-0.1s5.9-0.1,13.2-0.1S40.6,271.4,40.6,271.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.7,291.4c0,0.1-6.4,0.1-14.3,0.1s-14.3-0.1-14.3-0.1s6.4-0.1,14.3-0.1S41.7,291.3,41.7,291.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.8,
    y: 229.6,
    className: "st2",
    width: 66.2,
    height: 64.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "250.9,288.2 269.2,255.2 284.2,276.3 293.3,265.1 306.9,288.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.6,248.8c0,2.6-2.1,4.8-4.8,4.8c-2.6,0-4.8-2.1-4.8-4.8c0-2.6,2.1-4.8,4.8-4.8l0,0 C288.5,244,290.6,246.2,290.6,248.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.9,288.4c0,0,0-0.1,0-0.3s0-0.4,0-0.7c0-0.7,0-1.6,0-2.9c0-2.5,0-6.2-0.1-10.9c0-9.4-0.1-22.7-0.1-38.7 l0.3,0.3l-56,0c-0.1,0.1,0.6-0.6,0.3-0.3l0,0v7.2c0,2.4,0,4.8,0,7.1c0,4.7,0,9.3,0,13.8c0,9,0,17.5,0,25.3l-0.3-0.3l40.4,0.1 l11.4,0.1l3,0h0.8C306.7,288.3,306.8,288.3,306.9,288.4c0,0-0.1,0-0.2,0h-0.7h-3l-11.4,0.1l-40.6,0.1h-0.3v-0.3 c0-7.8,0-16.3,0-25.3c0-4.5,0-9.1,0-13.8v-14.3l0,0l0.3-0.3l56,0h0.3v0.3c-0.1,16.1-0.1,29.5-0.1,38.9c0,4.6-0.1,8.3-0.1,10.8 c0,1.2,0,2.2,0,2.8c0,0.3,0,0.5,0,0.7C307,288.2,306.9,288.3,306.9,288.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    className: "st1",
    width: 297.4,
    height: 169.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M350,294c0,0.1-78.2,0.2-174.6,0.2S0.8,294.1,0.8,294c0-0.1,78.2-0.2,174.6-0.2S350,293.9,350,294z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M309.8,231.6c2.2,1,3.8,2.8,4.6,5.1c0.8,2.2,1,4.6,0.7,6.9c-0.5,4.5-3,9.1-5.7,12.7c-3.8-3.3-4.8-9-5.1-12 C303.9,239.7,305.9,231,309.8,231.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M314,263.8c-0.6-2.6,0.3-5.3,2.3-7.1c2-1.7,4.6-2.6,7.3-2.4c1.2,0.1,2.5,0.4,3.2,1.4c0.6,1,0.7,2.2,0.1,3.2 c-0.6,1-1.4,1.8-2.4,2.4C321.2,263.4,317.7,264.8,314,263.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.6,266.4c-1.2-5.5-4.9-10.1-10-12.4c-1.3-0.6-3-0.9-4,0.1c-1,1-0.7,2.7-0.1,4c2.5,5.5,8.1,8.9,14.1,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.8,277.9c0-0.3,0.1-0.6,0.1-0.9c0.1-0.6,0.3-1.5,0.5-2.5c0.6-2.8,1.5-5.5,2.8-8.1c1.3-2.6,3.3-4.8,5.7-6.3 c0.7-0.5,1.5-0.8,2.4-1.1c0.2-0.1,0.5-0.1,0.7-0.2c0.1,0,0.2,0,0.2,0c-1.1,0.4-2.2,0.9-3.2,1.5c-2.4,1.6-4.3,3.7-5.5,6.3 c-1.3,2.5-2.2,5.2-2.8,8L309,277C308.9,277.3,308.9,277.6,308.8,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.9,238.4c0,0.1,0.1,0.3,0.1,0.4c0,0.3,0,0.7,0.1,1.2c0.1,1,0.1,2.5,0.2,4.3c0.2,3.6,0.3,8.6,0.4,14.1 c0,5.5,0,10.5-0.1,14.1c-0.1,1.8-0.1,3.3-0.1,4.3c0,0.5,0,0.9-0.1,1.2c0,0.1,0,0.3,0,0.4c0-0.1,0-0.3,0-0.4c0-0.3,0-0.7,0-1.2 c0-1,0-2.5,0.1-4.3c0-3.6,0.1-8.6,0-14.1c0-5.5-0.2-10.5-0.3-14.1c-0.1-1.8-0.1-3.2-0.1-4.3c0-0.5,0-0.9,0-1.2 C308.9,238.7,308.9,238.6,308.9,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298.4,258.2c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.1,0.6,0.3,0.9,0.5c0.4,0.2,0.8,0.5,1.2,0.7l0.7,0.5 c0.2,0.2,0.5,0.4,0.7,0.6c0.5,0.4,0.9,0.9,1.4,1.3c1,1.1,1.9,2.3,2.7,3.6c0.8,1.3,1.4,2.7,1.8,4.1c0.2,0.6,0.4,1.3,0.5,1.9 c0.1,0.3,0.1,0.6,0.2,0.9c0,0.3,0.1,0.6,0.1,0.8c0.1,0.5,0.1,1,0.1,1.4c0,0.4,0,0.7,0,1.1c0,0.3,0,0.6-0.1,0.9 c-0.1,0,0-1.3-0.2-3.4c0-0.3-0.1-0.5-0.1-0.8c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.6-0.3-1.2-0.5-1.9c-0.9-2.8-2.5-5.4-4.5-7.6 c-0.5-0.5-0.9-1-1.4-1.4c-0.2-0.2-0.4-0.4-0.7-0.6l-0.6-0.5C299.6,258.8,298.4,258.3,298.4,258.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "316.5,294 302.8,294 300,273.8 319.2,273.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.9,283.1c0,0.1-3.7,0.2-8.3,0.2s-8.3-0.1-8.3-0.2s3.7-0.2,8.3-0.2S317.9,283,317.9,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.9,284.3c0,0.1-3.7,0.2-8.3,0.2s-8.3-0.1-8.3-0.2s3.7-0.2,8.3-0.2S317.9,284.2,317.9,284.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 18.6,
    className: "st7",
    width: 294.5,
    height: 187.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.1,205.5c0-1.4-0.1-72.5-0.2-187.6l0.2,0.2L29.6,18.1l0,0l0.2-0.2c0,66.4,0,129.8,0,187.6l-0.2-0.2 L324.1,205.5l-294.5,0.2h-0.2v-0.2c0-57.8,0-121.2,0-187.6v-0.2h0.2l294.5,0.1h0.2v0.2C324.1,133,324.1,204,324.1,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.2,29.1c0,0.1-66,0.2-147.4,0.2S29.4,29.2,29.4,29.1c0-0.1,66-0.2,147.4-0.2S324.2,29,324.2,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.1,22.2c0,1.1-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9S39.1,21.1,39.1,22.2L39.1,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.9,22.2c0,1.1-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9S44.9,21.1,44.9,22.2L44.9,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.7,22.2c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9 C49.9,20.3,50.7,21.1,50.7,22.2L50.7,22.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 130.2,
    className: "st5",
    width: 60.7,
    height: 58.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "53.8,183.9 70.6,153.7 84.4,173 92.7,162.8 105.1,183.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2,147.8c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4c0,0,0,0,0,0C88.3,143.4,90.2,145.4,90.2,147.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.1,184.1c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.7c0-0.6,0-1.5,0-2.6c0-2.3,0-5.7-0.1-10c0-8.6-0.1-20.8-0.1-35.5 l0.3,0.2l-51.3,0l0.3-0.3v13.2c0,4.3,0,8.5,0,12.7c0,8.2,0,16,0,23.2l-0.2-0.2L91,184l10.5,0.1h2.8h0.7h0.3 C105.2,184,105.1,184,105.1,184.1l-0.8-0.1h-2.7l-10.4,0.1L54,184.2h-0.3V184c0-7.2,0-14.9,0-23.2c0-4.1,0-8.3,0-12.7v-13.1 l0.3-0.3l51.3,0h0.2v0.2c-0.1,14.7-0.1,27-0.1,35.6c0,4.3-0.1,7.6-0.1,9.9c0,1.1,0,2,0,2.6c0,0.3,0,0.5,0,0.7 C105.3,184,105.2,184,105.1,184.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 141.4,
    className: "st5",
    width: 41.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.7,150.2c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2s12.3-0.2,27.6-0.2 C161.3,150,173.7,150.1,173.7,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.7,156c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2s12.3-0.2,27.6-0.2S173.7,155.9,173.7,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.7,161.8c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2c0-0.1,12.3-0.2,27.6-0.2 C161.3,161.6,173.7,161.7,173.7,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.7,167.5c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2s12.3-0.2,27.6-0.2 C161.3,167.3,173.7,167.4,173.7,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.7,173.3c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2s12.3-0.2,27.6-0.2S173.7,173.2,173.7,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.8,178.6c0,0.1-6.3,0.2-14.2,0.2c-7.8,0-14.2-0.1-14.2-0.2s6.3-0.2,14.2-0.2S146.8,178.5,146.8,178.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.7,119c0.6-0.2,1.2-0.3,1.9-0.2l-0.2,0.2l0,0v-0.4v-0.4c0-0.2,0-0.4,0-0.6c0-0.3,0.1-0.5,0.1-0.5 c0.1,0,0.1,0.2,0.1,0.5c0,0.2,0,0.4,0,0.6v0.7l0,0l-0.2,0.2C169,119.3,168.3,119.2,167.7,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.3,119c1.2-0.3,2.5-0.3,3.7,0C162.8,119.3,161.5,119.3,160.3,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.8,119c1.2-0.3,2.5-0.3,3.7,0C155.3,119.3,154,119.3,152.8,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,119c1.2-0.3,2.5-0.3,3.7,0C147.8,119.3,146.6,119.3,145.3,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.9,119c0.6-0.2,1.2-0.3,1.9-0.2c0.6-0.1,1.3,0,1.9,0.2c-0.6,0.2-1.2,0.3-1.9,0.2 C139.1,119.3,138.5,119.2,137.9,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,119c1.2-0.3,2.5-0.3,3.7,0C132.9,119.3,131.6,119.3,130.4,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.9,119c1.2-0.3,2.5-0.3,3.7,0C125.4,119.3,124.2,119.3,122.9,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4,119c0.6-0.2,1.2-0.3,1.9-0.2c0.6-0.1,1.3,0,1.9,0.2c-0.6,0.2-1.2,0.3-1.9,0.2 C116.7,119.3,116.1,119.2,115.4,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108,119c1.2-0.3,2.5-0.3,3.7,0C110.5,119.3,109.2,119.3,108,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,119c1.2-0.3,2.5-0.3,3.7,0C103,119.3,101.7,119.3,100.5,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93,119c1.2-0.3,2.5-0.3,3.7,0C95.5,119.3,94.3,119.3,93,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.6,119c1.2-0.3,2.5-0.3,3.7,0C88.1,119.3,86.8,119.3,85.6,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.1,119c1.2-0.3,2.5-0.3,3.7,0C80.6,119.3,79.3,119.3,78.1,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.6,119c0.6-0.2,1.2-0.3,1.9-0.2c0.6-0.1,1.3,0,1.9,0.2c-0.6,0.2-1.2,0.3-1.9,0.2 C71.9,119.3,71.2,119.2,70.6,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.2,119c0.6-0.2,1.2-0.3,1.9-0.2c0.6-0.1,1.3,0,1.9,0.2c-0.6,0.2-1.2,0.3-1.9,0.2 C64.4,119.3,63.8,119.2,63.2,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,119c0.6-0.2,1.2-0.3,1.9-0.2c0.6-0.1,1.3,0,1.9,0.2c-0.6,0.2-1.2,0.3-1.9,0.2 C56.9,119.3,56.3,119.2,55.7,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,117.2c0.2,0.6,0.3,1.2,0.2,1.9l-0.2-0.2h0.7c0.2,0,0.4,0,0.6,0c0.3,0,0.5,0.1,0.5,0.1s-0.2,0.1-0.5,0.1 l-0.6,0h-0.4h-0.4l-0.2-0.2C49.8,118.4,49.9,117.8,50.1,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,109.8c0.3,1.2,0.3,2.5,0,3.7C49.8,112.3,49.8,111,50.1,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,102.4c0.3,1.2,0.3,2.5,0,3.7C49.8,104.9,49.8,103.7,50.1,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,95.1c0.3,1.2,0.3,2.5,0,3.7C49.8,97.6,49.8,96.3,50.1,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,87.7c0.3,1.2,0.3,2.5,0,3.7C49.8,90.2,49.8,88.9,50.1,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,80.4c0.3,1.2,0.3,2.5,0,3.7C49.8,82.8,49.8,81.6,50.1,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,73c0.3,1.2,0.3,2.5,0,3.7C49.8,75.5,49.8,74.2,50.1,73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,65.7c0.3,1.2,0.3,2.5,0,3.7C49.8,68.1,49.8,66.9,50.1,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,58.3c0.3,1.2,0.3,2.5,0,3.7C49.8,60.8,49.8,59.5,50.1,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.1,51c0.3,1.2,0.3,2.5,0,3.7C49.8,53.4,49.8,52.2,50.1,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,45.4c-0.6,0.2-1.2,0.3-1.9,0.2c0.4-0.4,0.1-0.1,0.2-0.2l0,0v0.4c0,0.1,0,0.2,0,0.4s0,0.4,0,0.6 c0,0.3-0.1,0.5-0.1,0.5S50,47.1,50,46.7c0-0.2,0-0.4,0-0.6v-0.7l0,0c0.1-0.1-0.2,0.2,0.2-0.2C50.7,45.2,51.4,45.2,52,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,45.4c-0.6,0.2-1.2,0.3-1.9,0.2c-0.6,0.1-1.3,0-1.9-0.2c0.6-0.2,1.2-0.3,1.9-0.2 C58.2,45.2,58.8,45.2,59.4,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,45.4c-0.6,0.2-1.2,0.3-1.9,0.2c-0.6,0.1-1.3,0-1.9-0.2c0.6-0.2,1.2-0.3,1.9-0.2 C65.7,45.2,66.3,45.2,66.9,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.4,45.4c-0.6,0.2-1.2,0.3-1.9,0.2c-0.6,0.1-1.3,0-1.9-0.2c0.6-0.2,1.2-0.3,1.9-0.2 C73.1,45.2,73.8,45.2,74.4,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.8,45.4c-1.2,0.3-2.5,0.3-3.7,0C79.3,45.2,80.6,45.2,81.8,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.3,45.4c-1.2,0.3-2.5,0.3-3.7,0C86.8,45.2,88,45.2,89.3,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.8,45.4c-1.2,0.3-2.5,0.3-3.7,0C94.3,45.2,95.5,45.2,96.8,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.3,45.4c-1.2,0.3-2.5,0.3-3.7,0C101.7,45.2,103,45.2,104.3,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,45.4c-1.2,0.3-2.5,0.3-3.7,0C109.2,45.2,110.5,45.2,111.7,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,45.4c-0.6,0.2-1.2,0.3-1.9,0.2c-0.6,0.1-1.3,0-1.9-0.2c0.6-0.2,1.2-0.3,1.9-0.2 C117.9,45.2,118.6,45.2,119.2,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.7,45.4c-1.2,0.3-2.5,0.3-3.7,0C124.1,45.2,125.4,45.2,126.7,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,45.4c-1.2,0.3-2.5,0.3-3.7,0C131.6,45.2,132.9,45.2,134.1,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.6,45.4c-0.6,0.2-1.2,0.3-1.9,0.2c-0.6,0.1-1.3,0-1.9-0.2c0.6-0.2,1.2-0.3,1.9-0.2 C140.4,45.2,141,45.2,141.6,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.1,45.4c-1.2,0.3-2.5,0.3-3.7,0C146.6,45.2,147.8,45.2,149.1,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,45.4c-1.2,0.3-2.5,0.3-3.7,0C154,45.2,155.3,45.2,156.5,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164,45.4c-1.2,0.3-2.5,0.3-3.7,0C161.5,45.2,162.8,45.2,164,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,47.3c-0.2-0.6-0.3-1.2-0.2-1.9c0.4,0.4,0.1,0.1,0.2,0.2h-0.4h-0.4h-0.6c-0.3,0-0.5-0.1-0.5-0.1 c0-0.1,0.2-0.1,0.5-0.1l0.6,0h0.7c0.1,0.1-0.2-0.2,0.2,0.2C169.9,46.1,169.8,46.7,169.6,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,54.6c-0.3-1.2-0.3-2.5,0-3.7C169.9,52.2,169.9,53.4,169.6,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,62c-0.3-1.2-0.3-2.5,0-3.7C169.9,59.5,169.9,60.8,169.6,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,69.4c-0.3-1.2-0.3-2.5,0-3.7C169.9,66.9,169.9,68.1,169.6,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,76.7c-0.3-1.2-0.3-2.5,0-3.7C169.9,74.3,169.9,75.5,169.6,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,84.1c-0.3-1.2-0.3-2.5,0-3.7C169.9,81.6,169.9,82.8,169.6,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,91.4c-0.3-1.2-0.3-2.5,0-3.7C169.9,88.9,169.9,90.2,169.6,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,98.8c-0.3-1.2-0.3-2.5,0-3.7C169.9,96.3,169.9,97.6,169.6,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,106.1c-0.2-0.6-0.3-1.2-0.2-1.8c-0.1-0.6,0-1.2,0.2-1.8c0.2,0.6,0.3,1.2,0.2,1.8 C169.9,104.9,169.8,105.5,169.6,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.6,113.5c-0.3-1.2-0.3-2.5,0-3.7C169.9,111,169.9,112.3,169.6,113.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.2,
    y: 130.1,
    className: "st9",
    width: 60.7,
    height: 58.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "192,183.9 208.8,153.6 222.5,172.9 230.8,162.7 243.3,183.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.4,147.7c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c0,0,0,0,0,0 C226.4,143.4,228.3,145.3,228.4,147.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.3,184c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.7c0-0.6,0-1.5,0-2.6c0-2.3,0-5.7-0.1-10c0-8.6-0.1-20.8-0.1-35.5l0.3,0.2 l-51.3,0l0.3-0.3v13.2c0,4.3,0,8.5,0,12.7c0,8.2,0,16,0,23.2l-0.2-0.2l37.1,0.1l10.5,0.1h2.8h0.7h0.3 C243.3,184,243.3,184,243.3,184l-0.8-0.1h-2.7l-10.4,0.1l-37.3,0.1h-0.3v-0.3c0-7.2,0-14.9,0-23.2c0-4.1,0-8.3,0-12.7V135 l0.3-0.3l51.3,0h0.2v0.2c-0.1,14.7-0.1,27-0.1,35.6c0,4.3-0.1,7.6-0.1,9.9c0,1.1,0,2,0,2.6c0,0.3,0,0.5,0,0.7 C243.4,183.9,243.4,184,243.3,184z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 141.3,
    className: "st9",
    width: 41.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.8,150.2c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2s12.3-0.2,27.6-0.2 C299.5,150,311.8,150,311.8,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.8,155.9c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2c0-0.1,12.3-0.2,27.6-0.2 C299.4,155.7,311.8,155.8,311.8,155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.8,161.7c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2c0-0.1,12.3-0.2,27.6-0.2 C299.5,161.5,311.8,161.6,311.8,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.8,167.5c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2s12.3-0.2,27.6-0.2 C299.5,167.3,311.8,167.4,311.8,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.8,173.3c0,0.1-12.3,0.2-27.6,0.2s-27.6-0.1-27.6-0.2c0-0.1,12.3-0.2,27.6-0.2 C299.4,173,311.8,173.1,311.8,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M285,178.5c0,0.1-6.3,0.2-14.2,0.2c-7.8,0-14.2-0.1-14.2-0.2s6.3-0.2,14.2-0.2S285,178.4,285,178.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    y: 45,
    className: "st9",
    width: 92.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.7,53.8c0,0.1-27.7,0.2-61.8,0.2s-61.8-0.1-61.8-0.2c0-0.1,27.7-0.2,61.8-0.2S311.7,53.7,311.7,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.7,59.6c0,0.1-27.7,0.2-61.8,0.2S188,59.7,188,59.6s27.7-0.2,61.8-0.2S311.7,59.5,311.7,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.7,77.3c0,0.1-27.7,0.2-61.8,0.2s-61.8-0.1-61.8-0.2c0-0.1,27.7-0.2,61.8-0.2S311.7,77.2,311.7,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.7,83.1c0,0.1-27.7,0.2-61.8,0.2s-61.8-0.1-61.8-0.2s27.7-0.2,61.8-0.2S311.7,83,311.7,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.7,88.9c0,0.1-27.7,0.2-61.8,0.2S188,89,188,88.9c0-0.1,27.7-0.2,61.8-0.2S311.7,88.8,311.7,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M251.6,94.1c0,0.1-14.2,0.2-31.8,0.2S188,94.3,188,94.1c0-0.1,14.2-0.2,31.8-0.2S251.6,94.1,251.6,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312,65.9c0,0.1-27.7,0.2-61.8,0.2s-61.8-0.1-61.8-0.2c0-0.1,27.7-0.2,61.8-0.2S312,65.8,312,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312,71.7c0,0.1-27.7,0.2-61.8,0.2s-61.9-0.1-61.9-0.2s27.7-0.2,61.8-0.2S312,71.6,312,71.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M194.8,44.9h22.9l0.2,6.9h-1c-0.5-2.2-1.1-3.6-1.8-4.2c-0.7-0.7-2.2-1-4.6-1h-2.2v20.7c0,1.6,0.2,2.5,0.7,2.9 c0.5,0.4,1.6,0.6,3.2,0.7v0.7h-11.8v-0.7c1.7-0.1,2.8-0.4,3.2-0.8c0.4-0.4,0.6-1.5,0.6-3.3V46.6H202c-2.2,0-3.8,0.3-4.6,1 c-0.8,0.6-1.4,2.1-1.8,4.2h-1L194.8,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,45.2c0,0.1-19.5,0.2-43.5,0.2s-43.5-0.1-43.5-0.2s19.5-0.2,43.5-0.2S311.7,45,311.7,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,51.8c0,0.1-19.5,0.2-43.5,0.2s-43.5-0.1-43.5-0.2s19.5-0.2,43.5-0.2S311.7,51.7,311.7,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,58.4c0,0.1-19.5,0.2-43.5,0.2s-43.5-0.1-43.5-0.2c0-0.1,19.5-0.2,43.5-0.2S311.7,58.3,311.7,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,65c0,0.1-19.5,0.2-43.5,0.2s-43.5-0.1-43.5-0.2s19.5-0.2,43.5-0.2S311.7,64.9,311.7,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,71.7c0,0.1-19.5,0.2-43.5,0.2s-43.5-0.1-43.5-0.2s19.5-0.2,43.5-0.2S311.7,71.6,311.7,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,78.3c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,78.2,311.7,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,84.6c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,84.5,311.7,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,90.9c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,90.8,311.7,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,97.2c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,97.1,311.7,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,103.6c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,103.4,311.7,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,109.9c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,109.8,311.7,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,116.2c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,116.1,311.7,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,122.5c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,122.4,311.7,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,129.1c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,129,311.7,129.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,135.5c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2c0-0.1,26.5-0.2,59.1-0.2S311.7,135.3,311.7,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,141.8c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2c0-0.1,26.5-0.2,59.1-0.2S311.7,141.7,311.7,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,148.1c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2c0-0.1,26.5-0.2,59.1-0.2S311.7,148,311.7,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,154.4c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2c0-0.1,26.5-0.2,59.1-0.2S311.7,154.3,311.7,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,160.7c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2s26.5-0.2,59.1-0.2S311.7,160.6,311.7,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,167c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2c0-0.1,26.5-0.2,59.1-0.2S311.7,166.9,311.7,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M311.7,173.3c0,0.1-26.5,0.2-59.1,0.2s-59.1-0.1-59.1-0.2c0-0.1,26.5-0.2,59.1-0.2S311.7,173.2,311.7,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.3,180.1c0,0.1-12.9,0.2-28.9,0.2s-28.9-0.1-28.9-0.2c0-0.1,12.9-0.2,28.9-0.2S251.3,180,251.3,180.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M161,118.4l-116.2,6.4c-0.9,0-1.6-0.6-1.7-1.5L39.3,53c-0.1-0.9,0.6-1.6,1.5-1.7L156.9,45 c0.9,0,1.6,0.6,1.7,1.5l3.9,70.3C162.5,117.6,161.9,118.4,161,118.4C161,118.4,161,118.4,161,118.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "101.7,77.4 111.8,82.2 102.8,88.9 93.7,95.6 92.7,84.1 91.6,72.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M153.6,111.5c0,0.1-22.9,1.4-51,3c-28.2,1.6-51.1,2.7-51.1,2.6s22.9-1.5,51.1-3 C130.7,112.6,153.6,111.4,153.6,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M53.2,117c0,0.7-0.5,1.3-1.2,1.4c-0.7,0-1.3-0.5-1.4-1.2c0-0.7,0.5-1.3,1.2-1.4 C52.6,115.7,53.2,116.3,53.2,117C53.2,117,53.2,117,53.2,117z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.8,45.4c-1.9,3.6-3.7,7.6-2.5,11.4c0.6,1.7,1.8,3.2,2.7,4.8c2.8,4.9,2.7,10.9,2.5,16.5c-0.1,1.6-0.2,3.4-1.4,4.4 c-1,0.9-2.4,1-3.7,1l-15.8,0.6v27.8l29.3-6.5L160.5,64l-0.7-7l-3-12L150.8,45.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "125.6,270.4 126.6,293.9 139.3,293.6 138.4,270.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.9,292.8c0.1,0-0.1-5.1-0.4-11.5s-0.7-11.5-0.8-11.5c-0.1,0,0.1,5.1,0.4,11.5 C132.4,287.7,132.7,292.8,132.9,292.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "126.6,292.2 139.2,291.9 139.3,293.6 126.6,293.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139,286.1c0,0-0.1-0.2-0.3-0.5c-0.9-1.1-2-1.9-3.3-2.4c-0.9-0.4-2-0.6-3-0.5c-1.9,0.1-3.6,0.9-4.8,2.4 c-0.4,0.4-0.6,0.9-0.9,1.4c-0.1,0.2-0.2,0.4-0.2,0.6c0.4-0.6,0.8-1.3,1.2-1.8c1.2-1.3,2.9-2.1,4.7-2.2c1.8,0,3.5,0.6,4.9,1.7 C138.4,285.4,138.9,286.1,139,286.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.6,276.7 138.7,279.3 126,279.6 125.9,277.6  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95,271l0.6,14.7c0,0-14.7,5.6-14.9,8.3l28.5-0.2l-0.1-22.9L95,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.3,284.4c0.6,0.2,0.9,0.7,0.8,1.3c-0.1,0.6-0.7,0.9-1.3,0.8c-0.6-0.2-1-0.8-0.9-1.4 c0.2-0.6,0.9-0.9,1.5-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.3,293.8v-2.3l-27.6,1c0,0-1.3,0.6-1.1,1.5L109.3,293.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.3,285.8c0,0.1,0.7,0.2,1.4,0.6s1.1,1,1.2,1c0.1-0.1-0.1-0.9-0.9-1.4C96.2,285.5,95.3,285.7,95.3,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.3,287c0,0.1,0.6,0.4,1.1,1c0.5,0.6,0.6,1.2,0.7,1.2s0.2-0.8-0.4-1.5C93.1,287,92.3,286.9,92.3,287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.7,290.7c0.1,0,0.3-0.7,0-1.4c-0.4-0.8-1-1.1-1.1-0.9c-0.1,0.1,0.4,0.5,0.6,1.2S90.5,290.6,90.7,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.6,282.4c0.1,0.1,0.7-0.1,1.5,0c0.8,0.1,1.4,0.3,1.5,0.2c0.1-0.1-0.5-0.6-1.5-0.7 C96.2,281.9,95.5,282.3,95.6,282.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95,279.2c0.5,0.1,1,0.1,1.4,0c0.5-0.1,1-0.3,1.5-0.5c0.3-0.1,0.6-0.3,0.8-0.4c0.2-0.1,0.3-0.2,0.4-0.3 c0.2-0.2,0.2-0.5,0.1-0.7c-0.1-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.4,0-0.5,0.1c-0.3,0.1-0.6,0.2-0.9,0.3c-0.5,0.2-0.9,0.5-1.3,0.9 c-0.7,0.6-0.9,1.2-0.8,1.2c0.1,0,0.4-0.4,1.1-0.9c0.4-0.3,0.8-0.6,1.3-0.7c0.3-0.1,0.6-0.2,0.8-0.3c0.3-0.1,0.6-0.1,0.6,0 s0,0.1,0,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.2-0.5,0.3-0.7,0.4c-0.4,0.2-0.9,0.4-1.4,0.5C96,279,95.5,279.1,95,279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.2,279.4c0.3-0.4,0.4-0.9,0.4-1.4c0-0.5,0-1.1-0.2-1.6c-0.1-0.3-0.2-0.6-0.4-0.9c-0.2-0.4-0.5-0.7-0.9-0.7 c-0.3,0-0.5,0.2-0.6,0.4c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.3,0,0.6,0,1c0.1,0.5,0.3,1.1,0.6,1.5c0.6,0.7,1.2,0.9,1.2,0.9 c0-0.1-0.4-0.3-0.9-1c-0.3-0.4-0.4-0.9-0.5-1.4c0-0.3,0-0.6,0-0.8c0-0.3,0.2-0.6,0.3-0.5s0.4,0.2,0.5,0.5c0.1,0.2,0.3,0.5,0.4,0.7 c0.2,0.5,0.3,0.9,0.3,1.4C95.3,278.9,95.2,279.4,95.2,279.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.3,279.7 109.2,282.9 95.5,282.9 95.5,281.1  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M152,47.7c-0.3,0-1.2,3.3-1.6,4.9c-0.1,0.6-0.1,1.2,0.2,1.8l3.3,5.8c0.6,1.1,1.5,2,2.6,2.6l1.7,0.9l0.2,3.5 l9.3,0.1l-2.8-10.9l-1.2-6.6c-0.3-0.7-0.9-1.1-1.7-1.2l-0.9-0.1l-0.3-0.8c-0.2-0.5-0.6-0.8-1.1-0.9l-0.5-0.1l-0.7-1.9 c-0.2-0.6-0.8-1-1.5-1l-4.5,0.1c0,0-1,1.3,1.3,2c0.6,0.2,1.3,0.3,1.9,0.2l1,4.1c0,0,0.7,4.3-1.3,4.3c-1.8,0-1.9-2.3-1.9-2.3 S154.3,47.4,152,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.2,51.8c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.7-0.7-1.2-1.3-1.6c-0.3-0.6-0.5-1.3-0.7-2 c-0.1-0.3-0.1-0.6-0.1-0.9c0,0,0.1,0.3,0.2,0.8c0.2,0.7,0.4,1.3,0.7,1.9l0.5,0.4c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.3,0.3,0.6,0.4,0.9 c0.1,0.2,0.1,0.4,0.1,0.6C161.2,51.6,161.2,51.7,161.2,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.6,51c0-0.1-0.1-0.3-0.1-0.4c-0.2-0.3-0.5-0.5-0.9-0.6h-0.1v0l-0.1-0.1c-0.2-0.5-0.4-1.1-0.5-1.7 c0.3,0.5,0.5,1.1,0.7,1.6l0.1,0.1l-0.1-0.1c0.4,0,0.8,0.3,0.9,0.7C162.7,50.8,162.6,51,162.6,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155.5,46.1c0,0-0.2-0.2-0.2-0.5c0-0.3,0.2-0.5,0.2-0.5c0,0,0,0.2-0.1,0.5C155.5,45.8,155.5,46.1,155.5,46.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.9,88.2l16.9-0.2l-1.9-14.4c0,0,1.2-0.2,1.2-6.5c0.1-6.2,0.4-16.9,0.4-16.9l0,0 c-7.2-3.1-15.6-2.1-21.8,2.7l-0.9,0.7L107.9,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.7,61.4c-0.1,0-4.3-1.3-4.2,3s4.4,3.3,4.4,3.1C103.9,67.4,103.7,61.4,103.7,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.7,60.5c0.1,0,3.9-1.1,3.7,3.2c-0.2,4.3-4.4,3.3-4.4,3.1C123.1,66.7,123.7,60.5,123.7,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.5,48.2c0.1-0.8-0.2-1.6-0.9-2.1c-0.6-0.5-1.5-0.4-2.1,0.2c0.2-1-0.4-2.1-1.4-2.3c-0.1,0-0.1,0-0.2,0 c-1-0.1-1.9,0.7-2.9,1c-1,0.2-2,0.1-2.9-0.3c-0.9-0.4-1.8-0.9-2.7-1.2c-4.1-1.5-8.7,0.6-10.2,4.7c-1.4-0.3-2.9,0.2-3.7,1.4 c-0.8,1.2-1.1,2.7-0.9,4.1c0.1,1,0.4,1.9,0.7,2.8c0,0.1,0,0.2,0,0.2c0.1,3.4,1.8,14.3,3.3,14.3c2.6,0,0.5-11.6,0.5-11.6 c3.1-1.2,2-5.9,2.7-6.6s2.4-2.4,9,1c2.4,1.1,5.2,1.4,7.8,0.8h0.2h0c0,0,0,0,0.1,0c0.6-0.2,1.2-0.4,1.7-0.7c0.6-0.4,1.1-0.9,1.4-1.5 c0.3-0.7,0.1-1.4-0.4-2C128.1,49.7,128.5,49,128.5,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.3,61c0.6,3.6,0.5,5.5,1.1,7.8c0.9,3.7,2.8,6.7,6.2,8.6s8,1.8,10.9-0.7c2-1.8,3.5-3.8,3.7-6.5 c0.3-2.7,0.6-7.4,0.6-10.1c0-4.9,0.4-9.5,0.4-9.5L111.4,48l-7.9,4.7L102.3,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.7,79.5c-0.8,0.3-1.6,0.4-2.4,0.2c-0.8,0-1.6-0.3-2.3-0.7c0-0.1,1.1,0.2,2.4,0.4 C115.6,79.5,116.7,79.4,116.7,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M120.3,47.3c-0.2,0.1-0.4,0.1-0.7,0.1c-0.6,0-1.2-0.1-1.8-0.4c-0.8-0.4-1.6-0.9-2.2-1.5 c-0.8-0.7-1.9-1.2-2.9-1.4c-1.1-0.1-2.2,0-3.2,0.6c-0.8,0.4-1.5,1.1-1.9,1.8c-0.4,0.7-0.7,1.5-0.8,2.3c0-0.2,0-0.4,0.1-0.7 c0.1-0.6,0.3-1.2,0.7-1.7c0.5-0.8,1.2-1.4,2-1.9c1-0.5,2.1-0.7,3.3-0.6c1.1,0.2,2.1,0.7,3,1.4c0.7,0.6,1.5,1.1,2.2,1.5 c0.5,0.3,1.1,0.4,1.7,0.5C120.1,47.4,120.3,47.3,120.3,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106.9,49.1c-0.3-0.2-0.7-0.3-1-0.4c-0.8-0.2-1.7,0-2.5,0.4c-0.7,0.5-1.2,1.2-1.4,2c-0.1,0.4-0.1,0.7-0.1,1.1 c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0.1-0.8c0.3-1.7,2-2.9,3.7-2.6c0.1,0,0.2,0,0.3,0.1c0.3,0.1,0.5,0.2,0.7,0.3 C106.8,49,106.8,49,106.9,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106.5,64.3c-0.9-1.4-1.6-2.9-2-4.5C105.4,61.2,106.1,62.7,106.5,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M110.2,66.8c-0.8-0.5-1.5-1.1-2-2c-0.6-0.8-0.9-1.7-1-2.6c0.1,0,0.5,1.1,1.3,2.4 C109.3,65.8,110.3,66.7,110.2,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M113.7,67.6c-0.6-0.2-1.2-0.5-1.7-1c-0.8-0.7-1.3-1.4-1.2-1.5c0.1-0.1,0.7,0.5,1.5,1.2 C113.1,66.9,113.8,67.5,113.7,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M120.1,61.8c0.1,0.7,0,1.5-0.4,2.1c-0.2,0.7-0.7,1.3-1.2,1.8c0.3-0.7,0.5-1.3,0.9-1.9 C119.6,63.1,119.8,62.4,120.1,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M122.2,58.4c0.2,0.9,0.1,1.8-0.2,2.6c-0.2,0.9-0.6,1.7-1.3,2.3c-0.1-0.1,0.5-1.1,0.9-2.4 C122.1,59.6,122.2,58.4,122.2,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.9,49.8c-0.2,0.2-0.3,0.3-0.6,0.4c-0.6,0.3-1.2,0.5-1.8,0.6c-1,0.1-1.9-0.1-2.8-0.4 c-1.1-0.4-2.1-1-3.1-1.6c-1-0.6-2.1-1-3.2-1.4c-0.9-0.2-1.9-0.2-2.8,0c-0.6,0.2-1.2,0.5-1.6,0.9c-0.3,0.3-0.4,0.5-0.4,0.5 c0.1-0.2,0.2-0.4,0.4-0.6c0.4-0.5,1-0.8,1.6-1c0.9-0.3,1.9-0.3,2.8-0.1c1.1,0.3,2.2,0.8,3.2,1.4c1,0.6,2,1.1,3.1,1.6 c0.9,0.4,1.8,0.5,2.8,0.5C122.4,50.6,123.2,50.3,123.9,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M125.2,51.8c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.2-0.7,0.3c-1.5,0.6-3.2,0.8-4.8,0.4 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.1-0.2-0.1c0,0,0.4,0.1,1,0.2c0.8,0.1,1.6,0.2,2.4,0.1c0.8-0.1,1.6-0.3,2.3-0.5 C124.8,52,125.1,51.8,125.2,51.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "117.4,180.8 121.5,220.4 124.4,279.9 140.1,279.9 140.6,153.2 95.6,156.4 86.3,222.9 94.4,281  111.6,281 107.6,225.7 117.4,180.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M117.4,180.8c-0.9,1.1-1.9,2.1-3.1,3c-1,1-2.1,1.9-3.3,2.7c0.9-1.1,1.9-2.1,3.1-3 C115.1,182.5,116.2,181.6,117.4,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M117.4,180.1c-0.1-1.7,0-3.4,0.1-5.1c0-1.7,0.1-3.4,0.3-5.1c0.2,1.7,0.2,3.4,0.1,5.1 C117.8,176.7,117.7,178.4,117.4,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M122.5,165.3c0.1,0,0.2,0,0.3,0l0.7,0l3-0.1l10.6-0.4h0.2v0.2c0,3.3,0,7.1,0,11.1v0.3l-0.1,0l-6.9,2.8h-0.1 h-0.1l-6.1-2.1H124v-0.1c-0.4-3.5-0.8-6.3-1.1-8.4c-0.1-1-0.2-1.7-0.3-2.3S122.5,165.4,122.5,165.3c0,0.1,0,0.2,0,0.3 c0,0.2,0.1,0.4,0.1,0.6c0.1,0.6,0.2,1.4,0.4,2.3c0.3,2,0.7,4.9,1.2,8.2l-0.1-0.1l6.1,2.1h-0.1l6.9-2.8l-0.1,0.2v-0.2 c0-4,0-7.7,0-11.1l0.2,0.2l-10.5,0.3l-3,0.1L122.5,165.3L122.5,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99.9,165.5c0.1,0,0.2,0,0.2,0h0.7l2.7-0.1l9.7-0.2h0.2v0.2c-0.1,3.3-0.2,7.1-0.4,11.1v0.1l-0.1,0.1l-1.1,0.7 l-5.7,3.7l-0.1,0.1l-0.1-0.1l-6.5-4l-0.1-0.1v-0.1c0.1-3.4,0.2-6.3,0.3-8.4c0-1,0.1-1.7,0.1-2.3C99.8,166,99.8,165.7,99.9,165.5 c0,0.1,0,0.1,0,0.2v0.6c0,0.6,0,1.4,0,2.3c0,2-0.1,4.9-0.1,8.2l-0.1-0.1l6.4,3.9h-0.2l5.7-3.7l1.1-0.7l-0.1,0.2 c0.1-4,0.3-7.8,0.4-11.1l0.2,0.2l-9.6,0.1h-3.5L99.9,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135.7,183.4c-0.7,0-1.4,0-2.1-0.1c-1.3-0.1-3.1-0.3-5.1-0.5c-2-0.3-3.8-0.5-5.1-0.8 c-0.7-0.1-1.4-0.3-2.1-0.5c0.7,0,1.4,0.1,2.1,0.2l5.1,0.7l5.1,0.6C134.3,183.1,135,183.2,135.7,183.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135.3,227.4c0,0-0.1,0.2-0.4,0.5c-0.5,0.4-1,0.6-1.6,0.5c-0.9,0-1.7-0.3-2.3-0.9c-0.8-0.7-1.5-1.4-2.1-2.2 c-1.2-1.4-2.3-2.9-3.2-4.5c-0.4-0.6-0.7-1.3-1-2c0.4,0.6,0.9,1.2,1.2,1.9c1,1.5,2.1,3,3.2,4.4c0.6,0.8,1.3,1.5,2.1,2.1 c0.6,0.5,1.3,0.8,2.1,0.9c0.5,0,1.1-0.1,1.5-0.4C135.2,227.6,135.3,227.4,135.3,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104.3,228.8c0,0,0,0.2-0.2,0.5c-0.3,0.4-0.6,0.8-1.1,1c-0.7,0.4-1.4,0.6-2.2,0.6c-0.9,0-1.8-0.3-2.6-0.8 c-1.4-0.9-2.4-2.2-3.1-3.7c-0.3-0.6-0.6-1.2-0.7-1.8c0.4,0.5,0.7,1.1,1,1.7c0.7,1.4,1.8,2.6,3.1,3.5c0.7,0.5,1.5,0.7,2.4,0.8 c0.7,0,1.4-0.1,2-0.4C103.5,229.8,104,229.3,104.3,228.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.3,222.9c-0.4,0.3-0.8,0.6-1.3,0.7c-1.1,0.5-2.3,0.7-3.5,0.7c-1.2,0.1-2.4-0.1-3.6-0.5 c-0.5-0.1-0.9-0.3-1.3-0.6c1.6,0.5,3.2,0.8,4.9,0.7C102.2,223.9,103.8,223.5,105.3,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M156.4,83.4h-22.9c0,0-3.1-1.8-4.6-1.5c-1.1,0.4-2.1,1-2.8,1.9l3,25.2l7.4-5.5l27.6-2.9c2.4,0,4.7-1,6.3-2.8 l0,0c1.8-1.9,2.6-4.5,2.3-7.1l-5.1-27.1l-10.5,0.4l-0.4,6.9L156.4,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.4,89.8c-2.5,1.5-4.4,3.8-5.5,6.4c-1.3,3.2-10.5,19.2-15.3,27.6c-1.7,3-1.3,6.9,1.1,9.4l0,0 c2.9,3,7.8,3.9,12.1,2.5c1.9-0.6,9.6-6.8,9.6-6.8L93.4,89.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "97.4,147 92.1,101.8 93.4,89.8 106.8,84.1 124.1,82.9 140.6,84.7 136.7,131.1 140.9,157.2  94.8,159.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.4,146.8c-0.1,0-1.4-10-2.8-22.5s-2.5-22.5-2.4-22.5s1.4,10.1,2.8,22.5S97.5,146.8,97.4,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M140.2,94.9c0,0.1,0,0.3,0,0.4c0,0.3-0.1,0.7-0.1,1.2c-0.1,1.1-0.3,2.5-0.4,4.3c-0.4,3.6-0.9,8.6-1.4,14.1 c-0.5,5.5-1,10.5-1.2,14.1c-0.1,1.8-0.2,3.2-0.3,4.3c0,0.5-0.1,0.9-0.1,1.2c0,0.1,0,0.3-0.1,0.4c0-0.1,0-0.3,0-0.4 c0-0.3,0-0.7,0-1.2c0-1,0.1-2.5,0.2-4.3c0.2-3.6,0.6-8.6,1.1-14.1c0.5-5.5,1.1-10.5,1.5-14.1c0.2-1.8,0.4-3.2,0.6-4.2 c0.1-0.5,0.1-0.8,0.2-1.2C140.1,95.1,140.2,95,140.2,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.3,139.9c-0.2,0.3-0.5,0.6-0.7,0.9c-0.3,0.3-0.6,0.7-0.9,1c-0.4,0.4-0.8,0.8-1.3,1.2 c-0.6,0.5-1.1,0.9-1.7,1.3c-0.7,0.5-1.4,0.9-2.1,1.3c-3.4,1.9-7.1,3-10.9,3.3c-0.9,0-1.7,0.1-2.5,0.1c-0.7,0-1.5-0.1-2.2-0.1 c-0.6-0.1-1.2-0.2-1.8-0.3c-0.4-0.1-0.9-0.2-1.3-0.3c-0.4-0.1-0.7-0.2-1.1-0.3c0-0.1,1.6,0.4,4.2,0.7c0.7,0.1,1.4,0.1,2.2,0.1 c0.7,0,1.6,0,2.5-0.1c3.8-0.3,7.4-1.4,10.8-3.2c0.7-0.4,1.5-0.8,2.1-1.3c0.6-0.4,1.2-0.9,1.7-1.3 C131.2,141.1,132.2,139.8,132.3,139.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.9,148.3c-2.2-0.6-2.4-2.8-1.5-3.7c0.9-0.9,2.2-1,3.5-0.8c1.2,0.3,2.5,0.5,3.7,0.5c2.1-0.1,3.7-1.6,5.2-3 c1.5-1.5,2.8-3.1,4.7-4c1.9-0.9,4.5-0.5,5.5,1.3c0.6,1.2,0.5,2.6-0.2,3.7c-0.7,1.1-1.7,2-2.8,2.7 C120.7,148.6,114.1,149.8,107.9,148.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94,118.4c-0.4,0.6-4.3,5.9-4.3,5.9c-0.1,0.5-3.9,5.4-3.9,5.4s3.4-1.9,5.9-3.2c1.1-0.6,2.1-1.4,3.1-2.2c0,0-0.6-3.7-0.8-5 c-0.6-3.1-1-10-1-10"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.2,84.3c1.2,0.4,2.3,1.3,3,2.4c0.8,1,1.3,2.3,1.3,3.6C138.8,87.9,137.3,85.8,135.2,84.3L135.2,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94,118.4c-0.3,0.6-0.7,1.3-1.1,1.8c-0.7,1.1-1.8,2.6-3,4.2c-2.4,3.3-4.4,5.9-4.5,5.7l1.2-1.7l3-4.2 c1.2-1.6,2.2-3.1,3-4.2C93.1,119.5,93.6,118.9,94,118.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.9,
    y: 242.9,
    className: "st4",
    width: 45.2,
    height: 45.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.8,
    y: 241.2,
    className: "st14",
    width: 46.1,
    height: 47.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.4,
    y: 240.2,
    className: "st4",
    width: 47.8,
    height: 47.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.6,
    y: 239.5,
    transform: "matrix(3.665183e-03 -1 1 3.665183e-03 -75.3248 450.5327)",
    className: "st5",
    width: 47.6,
    height: 47.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.4,282.7 181.6,258.3 192.2,274 198.7,265.7 208.3,282.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.8,253.6c-0.1,1.9-1.7,3.3-3.6,3.2c-1.9-0.1-3.3-1.7-3.2-3.6c0.1-1.8,1.6-3.2,3.4-3.2 C195.3,250,196.9,251.6,196.8,253.6C196.8,253.6,196.8,253.6,196.8,253.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.3,283c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.6c0-0.5,0-1.2,0-2.1c0-1.9,0-4.6,0-8.1c0-7,0-16.9,0-28.8l0.2,0.2 l-39.8-0.1c-0.1,0.1,0.4-0.4,0.2-0.2l0,0v2.7c0,0.9,0,1.8,0,2.7c0,1.8,0,3.6,0,5.3c0,3.5,0,6.9,0,10.3c0,6.7-0.1,13-0.1,18.8 l-0.2-0.2l28.8,0.2l8.1,0.1l2.2,0L208.3,283l0.1,0L208.3,283l-0.6,0h-2.1h-8.1h-29.2v-0.2c0-5.8,0-12.1,0.1-18.8 c0-3.3,0-6.7,0-10.3c0-1.8,0-3.5,0-5.3c0-0.9,0-1.8,0-2.7V243l0.2-0.2l39.8,0.2h0.2v0.2c-0.1,11.9-0.2,21.9-0.2,28.9 c0,3.4-0.1,6.2-0.1,8c0,0.9,0,1.6,0,2.1c0,0.2,0,0.4,0,0.5C208.3,282.8,208.3,282.9,208.3,283z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M161.8,261.1v33.2h64.7v-33.2H161.8z M188.6,268.9h-12.5c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9 c0,0,0,0,0,0h12.5c1,0,1.9,0.9,1.9,1.9C190.5,268,189.6,268.9,188.6,268.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.4,
    y: 261.1,
    className: "st4",
    width: 21.1,
    height: 33.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkCro);
export default __webpack_public_path__ + "static/media/hk_cro.ad0e12dbf5afb1361e381a2a0255f077.svg";
export { ForwardRef as ReactComponent };